<template>

<div class="faq">

	<slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.faq {
	border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.modal-wrapper.is-large .faq {
	margin-top: 20px;
	border: 1px solid #eee;
	border-radius: 10px;
}

</style>